import TutorialViewPage from './view'
export default TutorialViewPage
